export default __webpack_public_path__ + "static/media/MyDohwaji.e7753a1e.svg";